import React from "react";
import "./App.css";
// import { HashRouter, Routes, Route } from "react-router-dom"; // Removed for single page scroll
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Programs from "./components/Programs";
import ClassOptions from "./components/ClassOptions";
import Advantages from "./components/Advantages";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Programs />
      <ClassOptions />
      <Advantages />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
